/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Bondsmith Savings Exchange Operation Portal APIs
 * OpenAPI spec version: 0.1
 */

export type PreloadedAccountStatus =
  typeof PreloadedAccountStatus[keyof typeof PreloadedAccountStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PreloadedAccountStatus = {
  PLACEHOLDER: 'PLACEHOLDER',
  AVAILABLE: 'AVAILABLE',
  ASSIGNED: 'ASSIGNED',
  RESERVED: 'RESERVED',
} as const;
